var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo, useState } from 'react';
import { useLayer } from 'react-laag';
import styled from 'styled-components';
import { Btn } from '../button/btn-type/Btn';
import { Icon } from '../Icon/Icon';
import { SplitButtonContainer, SplitButtonList, SplitButtonOption } from './SplitButton.styling';
/**
 *  @example
 * ```jsx
 *  <SplitButton
 *      icon="add"
 *      options={[
 *          {
 *              title: 'Create a merge commit',
 *              description:
 *                  'When requirements are met, all commits from this branch will be added to the base branch via a merge commit',
 *          },
 *          {
 *              title: 'Squash and merge',
 *              description:
 *                  ' When requirements are met, the 2 commits from this branch will be combined into one commit in the base branch. ',
 *          },
 *          {
 *              title: 'Rebase and merge',
 *              description:
 *                  'When requirements are met, the 2 commits from this branch will be rebased and added to the base branch.',
 *          },
 *          {
 *              title: 'Custom merge commit',
 *              description:
 *                  'When requirements are met, the 2 commits from this branch will be combined into one commit in the base branch. ',
 *              isDisabled: true,
 *          },
 *      ]}
 *      onClick={(option) => console.log(option)}
 *      color="primary" />
 * ```
 */
export var SplitButton = function (_a) {
    var color = _a.color, icon = _a.icon, _b = _a.defaultIndex, defaultIndex = _b === void 0 ? 0 : _b, isDisabled = _a.isDisabled, options = _a.options, subtle = _a.subtle, onClick = _a.onClick, onOptionSelected = _a.onOptionSelected;
    var _c = useState(false), isSplitBtnOpen = _c[0], setIsSplitBtnOpen = _c[1];
    var _d = useState(defaultIndex), selectedOptionIndex = _d[0], setSelectedOptionIndex = _d[1];
    var currentOption = useMemo(function () { return options[selectedOptionIndex]; }, [options, selectedOptionIndex]);
    var handleOptionClick = function (index) {
        var option = options[index];
        if (option.isDisabled)
            return;
        setSelectedOptionIndex(index);
        onOptionSelected === null || onOptionSelected === void 0 ? void 0 : onOptionSelected(option, {
            setSelectedOptionIndex: setSelectedOptionIndex,
            options: options,
        });
        setIsSplitBtnOpen(false);
    };
    var handleMainButtonClick = function () {
        onClick === null || onClick === void 0 ? void 0 : onClick(currentOption, { setIsDropdownOpen: setIsSplitBtnOpen });
    };
    var _e = useLayer({
        isOpen: isSplitBtnOpen,
        onOutsideClick: function () { return setIsSplitBtnOpen(false); },
        placement: 'bottom-start',
        auto: true,
        triggerOffset: 8,
    }), renderLayer = _e.renderLayer, triggerProps = _e.triggerProps, layerProps = _e.layerProps;
    var colorValue = typeof color === 'function' ? color(currentOption) : color;
    var iconName = typeof icon === 'function' ? icon(currentOption) : icon;
    return (React.createElement("div", null,
        React.createElement(SplitButtonContainer, null,
            React.createElement(Btn, __assign({}, triggerProps, { type: "button", color: colorValue, disabled: isDisabled, subtle: subtle, onClick: handleMainButtonClick }),
                iconName && React.createElement(Icon, { name: iconName }),
                typeof currentOption.title === 'function'
                    ? currentOption.title(currentOption, true)
                    : currentOption.title),
            React.createElement(Btn, { type: "button", color: colorValue, disabled: isDisabled, subtle: subtle, onClick: function () { return setIsSplitBtnOpen(!isSplitBtnOpen); } },
                React.createElement(Icon, { name: "KeyboardArrowDown" }))),
        isSplitBtnOpen &&
            renderLayer(React.createElement(Wrapper, __assign({}, layerProps),
                React.createElement(SplitButtonList, null, options.map(function (option, index) { return (React.createElement("div", { key: index, onClick: function () { return handleOptionClick(index); } },
                    React.createElement(SplitButtonOption, { className: "".concat(option.isDisabled ? 'disabled' : '', " ").concat(selectedOptionIndex === index ? 'optionIsSelected' : ''), title: React.createElement(React.Fragment, null, typeof option.title === 'function'
                            ? option.title(option, false)
                            : option.title), description: option.description && React.createElement(React.Fragment, null, option.description) }))); }))))));
};
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    z-index: 1000;\n"], ["\n    z-index: 1000;\n"])));
var templateObject_1;
